import { PurchaseOrderService } from "src/services";
import { FILE_TYPE_SUFFIX } from "src/helpers";
import { PurchaseOrderFileType } from "src/enums";
import { useFileDownload } from "../useFileDownload";

export const usePurchaseOrderFileDownload = (purchaseOrderService: PurchaseOrderService) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: fileLoadError,
    retry: retryDownload,
    reset: resetDownload
  } = useFileDownload<File | File[]>();

  const downloadPurchaseOrderFile = (purchaseOrderId: string, purchaseOrderFileType: PurchaseOrderFileType) => {
    switch (purchaseOrderFileType) {
      case PurchaseOrderFileType.INVOICES:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderInvoices(purchaseOrderId),
          zipName: `${purchaseOrderId}${FILE_TYPE_SUFFIX[purchaseOrderFileType]}`
        });
        break;
      case PurchaseOrderFileType.PACKING_LISTS:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderPackingLists(purchaseOrderId),
          zipName: `${purchaseOrderId}${FILE_TYPE_SUFFIX[purchaseOrderFileType]}`
        });
        break;
      case PurchaseOrderFileType.COMPLIANCE:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderComplianceDocuments(purchaseOrderId),
          zipName: `${purchaseOrderId}${FILE_TYPE_SUFFIX[purchaseOrderFileType]}`
        });
        break;
      case PurchaseOrderFileType.PDF:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderPDF(purchaseOrderId, "PDF")
        });
        break;
      case PurchaseOrderFileType.CSV:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderPDF(purchaseOrderId, "CSV")
        });
        break;
      case PurchaseOrderFileType.COMMERCIAL_INVOICE:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderCommercialInvoice(purchaseOrderId, "PDF")
        });
        break;
      case PurchaseOrderFileType.COMMERCIAL_INVOICE_CSV:
        download({
          getFileData: () => purchaseOrderService.getPurchaseOrderCommercialInvoice(purchaseOrderId, "CSV")
        });
        break;
    }
  };

  return {
    downloadFile: downloadPurchaseOrderFile,
    isFileDownloading,
    fileLoadError,
    retryDownload,
    resetDownload
  };
};
